export default {"src":"/planos/_next/static/media/proposal-error.c71fe00d.svg","height":150,"width":168,"blurWidth":0,"blurHeight":0};